export const CUSTOM_LOCATION_TYPES = ['HOME', 'LOCATION', 'WORK', 'FAVOURITES']; // these need to be ignored / overwritten for stopover functionality